// Collection page functions for Blush & Glow

// Add to Bag functionality
document.addEventListener('DOMContentLoaded', function() {
  
  // Add to bag from product cards
  const addToBagButtons = document.querySelectorAll('.add-to-bag');
  addToBagButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      const variantId = this.dataset.variantId;
      addToCart(variantId, this);
    });
  });
  
  // Quick view functionality
  const quickViewButtons = document.querySelectorAll('.quick-view');
  quickViewButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      const productHandle = this.dataset.productHandle;
      openQuickView(productHandle);
    });
  });
  
  // Close quick view
  const panel = document.getElementById('quick-view-panel');
  if (panel) {
    const closeButton = panel.querySelector('.quick-view-close');
    const backdrop = panel.querySelector('.quick-view-backdrop');
    
    if (closeButton) {
      closeButton.addEventListener('click', closeQuickView);
    }
    
    if (backdrop) {
      backdrop.addEventListener('click', closeQuickView);
    }
    
    // ESC key to close
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && panel.getAttribute('aria-hidden') === 'false') {
        closeQuickView();
      }
    });
  }
});

// Add to cart function
function addToCart(variantId, button) {
  const originalText = button.textContent;
  button.disabled = true;
  button.textContent = 'ADDING...';
  
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      id: variantId,
      quantity: 1
    })
  })
  .then(response => response.json())
  .then(data => {
    button.textContent = 'ADDED!';
    
    // Update cart count if element exists
    updateCartCount();
    
    // Reset button after 2 seconds
    setTimeout(() => {
      button.disabled = false;
      button.textContent = originalText;
    }, 2000);
  })
  .catch(error => {
    console.error('Error adding to cart:', error);
    button.textContent = 'ERROR';
    
    setTimeout(() => {
      button.disabled = false;
      button.textContent = originalText;
    }, 2000);
  });
}

// Update cart count
function updateCartCount() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const cartCountElements = document.querySelectorAll('.cart-count, [data-cart-count]');
      cartCountElements.forEach(element => {
        element.textContent = cart.item_count;
      });
    })
    .catch(error => console.error('Error updating cart count:', error));
}

// Open quick view panel
function openQuickView(productHandle) {
  const panel = document.getElementById('quick-view-panel');
  const content = document.getElementById('quick-view-content');
  
  if (!panel || !content) return;
  
  // Show loading state
  content.innerHTML = '<div class="loading-spinner">Loading...</div>';
  panel.setAttribute('aria-hidden', 'false');
  document.body.style.overflow = 'hidden';
  
  // Fetch product data
  fetch(`/products/${productHandle}.js`)
    .then(response => response.json())
    .then(product => {
      populateQuickView(product);
    })
    .catch(error => {
      console.error('Error loading product:', error);
      content.innerHTML = '<p style="padding: 40px; text-align: center;">Error loading product. Please try again.</p>';
    });
}

// Close quick view panel
function closeQuickView() {
  const panel = document.getElementById('quick-view-panel');
  if (panel) {
    panel.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
}

// Populate quick view with product data
function populateQuickView(product) {
  const content = document.getElementById('quick-view-content');
  if (!content) return;
  
  // Get first 3 tags for badges
  const tags = product.tags.slice(0, 3);
  
  // Build the HTML
  let html = `
    <img src="${product.featured_image}" alt="${escapeHtml(product.title)}" class="qv-image">
    
    ${product.vendor ? `<span class="qv-brand">${escapeHtml(product.vendor)}</span>` : ''}
    <h2 class="qv-title">${escapeHtml(product.title)}</h2>
    <p class="qv-description">${stripHtml(product.description).substring(0, 200)}...</p>
    
    ${tags.length > 0 ? `
      <div class="qv-badges">
        ${tags.map(tag => `<span class="qv-badge">${escapeHtml(tag)}</span>`).join('')}
      </div>
    ` : ''}
    
    <div class="qv-price-variant">
      <span class="qv-price" data-price-display>${formatMoney(product.price)}</span>
      
      ${product.variants.length > 1 ? `
        <div class="qv-variant-selector">
          ${product.variants.slice(0, 3).map((variant, index) => `
            <button class="qv-variant-btn ${index === 0 ? 'active' : ''}" 
                    data-variant-id="${variant.id}"
                    data-variant-price="${variant.price}"
                    onclick="selectVariant(this, ${variant.id}, ${variant.price})">
              ${escapeHtml(variant.option1)}
            </button>
          `).join('')}
        </div>
      ` : ''}
    </div>
    
    <div class="qv-add-to-bag-row">
      <select class="qv-quantity" id="qv-quantity">
        <option value="1">1</option>
        <option value="2">2</option>
        <option value="3">3</option>
        <option value="4">4</option>
        <option value="5">5</option>
      </select>
      <button class="qv-add-btn" data-variant-id="${product.variants[0].id}" onclick="addToBagFromQuickView(this)">
        ADD TO BAG
      </button>
    </div>
    
    <a href="/products/${product.handle}" class="qv-view-all">VIEW ALL DETAILS</a>
  `;
  
  content.innerHTML = html;
}

// Select variant in quick view
function selectVariant(button, variantId, price) {
  // Update active state
  const allButtons = document.querySelectorAll('.qv-variant-btn');
  allButtons.forEach(btn => btn.classList.remove('active'));
  button.classList.add('active');
  
  // Update price display
  const priceDisplay = document.querySelector('[data-price-display]');
  if (priceDisplay) {
    priceDisplay.textContent = formatMoney(price);
  }
  
  // Update add to bag button
  const addButton = document.querySelector('.qv-add-btn');
  if (addButton) {
    addButton.dataset.variantId = variantId;
  }
}

// Add to bag from quick view
function addToBagFromQuickView(button) {
  const variantId = button.dataset.variantId;
  const quantity = document.getElementById('qv-quantity')?.value || 1;
  
  button.disabled = true;
  button.textContent = 'ADDING...';
  
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      id: variantId,
      quantity: parseInt(quantity)
    })
  })
  .then(response => response.json())
  .then(data => {
    button.textContent = 'ADDED!';
    updateCartCount();
    
    setTimeout(() => {
      closeQuickView();
    }, 1000);
  })
  .catch(error => {
    console.error('Error adding to cart:', error);
    button.textContent = 'ERROR';
    button.disabled = false;
  });
}

// Format money (cents to dollars)
function formatMoney(cents) {
  return '$' + (cents / 100).toFixed(2);
}

// Escape HTML to prevent XSS
function escapeHtml(text) {
  const div = document.createElement('div');
  div.textContent = text;
  return div.innerHTML;
}

// Strip HTML tags
function stripHtml(html) {
  const div = document.createElement('div');
  div.innerHTML = html;
  return div.textContent || div.innerText || '';
}